<template>
  <div class="card">
    <div class="card-body general-details" v-if="contactInfo">
      <h4 class="font-weight-bold d-block mb-4">Contact Details</h4>
      <!--  -->
      <ifac-loader class="p-5" v-if="busy"></ifac-loader>
      <div v-else>
        <div class="row my-4 text-center" v-if="contactInfo.length === 0">
          <div class="col">
            <div class="mb-4">
              <i class="far fa-exclamation fa-4x text-primary"></i>
            </div>
            <p>No contact info stored</p>
          </div>
        </div>
        <div class="row" v-else>
          <div class="col-12 col-md-6 mt-3" v-for="ci in contactInfo" :key="ci.id">
            <div class="card border-0 shadow-none bg-light">
              <div class="card-body">
                <div class="type-badge">
                  <div class="d-flex align-items-center">
                    <PrivateContact :affiliate-id="affiliateId" :contact-info="ci"/>
                    <span class="ml-2 badge badge-pill badge-primary p-2">
                      <span class="font-weight-bold text-uppercase mb-0">
                        {{ ci.type }}
                      </span>
                    </span>
                  </div>
                </div>
                <div class="row">
                  <div class="col">
                    <h5 class="font-weight-bold text-primary text-uppercase">
                      {{ ci.format }}
                    </h5>
                  </div>
                </div>
                <p class="text-dark mb-0" v-if="ci.format === 'phone'">
                  {{ ci.info }}
                </p>
                <p class="text-dark mb-0" v-else>{{ ci.info }}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!--  -->
    </div>
  </div>
</template>

<script>
import Affiliates from '@/services/Api/Affiliates';
import AffiliatesPublic from '@/services/Api/Public/Affiliates';
import { IfacLoader } from '@ifac/ui';
import { mapGetters } from 'vuex';
import PrivateContact from '@/views/components/tooltips/PrivateContact.vue';

export default {
  data() {
    return {
      busy: false,
      contactInfo: [],
    };
  },
  computed: {
    ...mapGetters({
      authed: 'auth/isAuthenticated',
    }),
    affiliateId() {
      return this.$route.params.id;
    },
    fullName() {
      return `${this.contactInfo.title} ${this.contactInfo.name} ${this.contactInfo.surname}`;
    },
  },
  methods: {
    async fetchAffiliate() {
      const {
        data: { data },
      } = await Affiliates.show(this.$route.params.id);

      this.contactInfo = data.contactInfo;
    },
    async fetchAffiliatePublic() {
      const {
        data: { data },
      } = await AffiliatesPublic.show(this.$route.params.id);

      this.contactInfo = data.contactInfo;
    },
    async fetchData() {
      this.busy = true;
      if (this.authed) {
        await this.fetchAffiliate();
      } else {
        await this.fetchAffiliatePublic();
      }
      this.busy = false;
    },
  },
  created() {
    this.fetchData();
  },
  components: {
    PrivateContact,
    IfacLoader,
  },
};
</script>

<style>
.type-badge {
  position: absolute;
  top: 0.5rem;
  right: 0.5rem;
  z-index: 9;
}
</style>
